import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ExportBuilder from '../components/ExportBuilder';

export default function ExportBuilderPage() {
  return (
    <DashboardLayout>
      <ExportBuilder />
    </DashboardLayout>
  );
}
